import React from 'react'

import { FieldSchema } from '@/lib/builder/schemas'

import { Switch } from '@/components/ui/switch'

interface BooleanFieldProps {
  field: FieldSchema
  value: boolean
  onChange: (value: boolean) => void
}

export const BooleanField = ({ field, value, onChange }: BooleanFieldProps) => {
  return (
    <div className="flex items-center justify-between border p-3 rounded-lg bg-background">
      <span className="text-sm font-medium text-muted-foreground">
        {value ? 'Enabled' : 'Disabled'}
      </span>
      <Switch checked={!!value} onCheckedChange={onChange} />
    </div>
  )
}
